import { GetStaticProps } from "next";
import SupportPage from "../../components/pages/platform/SupportPage";
import { GetAllNetworks } from "../../components/helpers";
import Layout from "../../components/layouts/PlatformLayout";
import Head from "next/head";

export default function Platform({ user, token, busy, usage, setUser, networks, handleToast }) {
    
    const isLoggedIn = user.match({
        None: () => false,
        Some: () => true
    });

    return <><Head><link
        rel="canonical"
        href={`https://www.covalenthq.com/platform/support/`}
        key="canonical" /></Head><Layout user={user}><SupportPage busy={busy} isLoggedIn={isLoggedIn} user={user} token={token} usage={usage} setUser={setUser} networks={networks} handleToast={handleToast} /></Layout></>;

}

export const getStaticProps: GetStaticProps = async () => {
    const networks = await GetAllNetworks();
    return {
        props: {
            networks,
            component: "Platform",
        },
    };
};
